export const ACTION_START_LOADING = "ACTION_START_LOADING";
export const ACTION_END_LOADING = "ACTION_END_LOADING";
export const ACTION_LOADED = "ACTION_LOADED";
